import React from 'react';
import { Button, Stack, StackProps, Typography } from '@mui/material';
import { TP_COLORS } from '../../constants';

interface SuccessViewProps {
  reference?: string;
  title?: string;
  homeURL: string;
}

const stackProps: StackProps = {
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  style: {
    height: 'calc(100vh - 64px)',
    padding: '0 15px',
  },
};

const SuccessView: React.FC<SuccessViewProps> = ({
  reference,
  title,
  homeURL,
}) => {
  return (
    <Stack {...stackProps}>
      <div style={{ marginBottom: '15px' }}>
        <img
          src={`${process.env.PUBLIC_URL}/images/payment/payment-success.png`}
          alt="payment-success"
          width="100%"
          style={{ maxWidth: '350px' }}
        />
      </div>
      <div>
        <Typography fontSize="20px" fontWeight={600}>
          Successfully Subscribed for {title}
        </Typography>
      </div>
      <div style={{ margin: '15px 0 40px 0' }}>
        <Typography color="secondary" fontWeight={500}>
          Reference : {reference || ''}
        </Typography>
        <Typography color="secondary" fontWeight={500}>
          Our team will be in touch with you shortly.
        </Typography>
        <Typography color="secondary" fontWeight={500}>
          Please contact{' '}
          <a
            href="https://support.tutopiya.com/portal/"
            target="_blank"
            rel="noreferrer"
            style={{ color: TP_COLORS.tutopiyaGreenMain.light }}
          >
            our support team
          </a>{' '}
          in case of any query.
        </Typography>
      </div>
      <Button
        size="large"
        variant="contained"
        color="primary"
        href={homeURL}
        sx={{ fontWeight: '600' }}
      >
        Back to Home
      </Button>
    </Stack>
  );
};

export default SuccessView;
